import { api } from '../axios'
import type { ApiResponse, ManagementType } from '../../../types'

export const managementTypesApi = {
  getAll: () =>
    api.get<ApiResponse<ManagementType[]>>('/management-types'),

  getActive: () =>
    api.get<ApiResponse<ManagementType[]>>('/management-types/active'),

  getById: (id: number) =>
    api.get<ApiResponse<ManagementType>>(`/management-types/${id}`),

  create: (data: ManagementType) =>
    api.post<ApiResponse<ManagementType>>('/management-types', data),

  update: (id: number, data: Partial<ManagementType>) =>
    api.put<ApiResponse<ManagementType>>(`/management-types/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/management-types/${id}`),
  
  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/management-types/${id}/permanent`),
}

